// extracted by mini-css-extract-plugin
module.exports = {"container":"mi","addToButton":"ni","basic":"oi","disabled":"pi","m-heart-activate":"qi","lists":"ri","addNew":"si","m-heart-pulse":"ti"};